module.exports = __webpack_public_path__ + "static/img/07-tzzM.980770e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/07-tzzM.png
// module id = 8wZI
// module chunks = 1